import React, { useState } from "react";
import { Paper, Box, Typography, Grid } from "@mui/material";
import dayjs from "dayjs";
import { industriesRequest } from "../../../remote/industriesRequest";
import { partnersRequest } from "../../../remote/partnersRequest";
import SelectSkills from "../../../components/FormComponents/SelectSkills";
import LoadingCircle from "../../../components/LayoutComponents/LoadingCircle";
import CustomDropdown from "../../../components/FormComponents/CustomDropdown";
import CustomDatePicker from "../../../components/FormComponents/CustomDatePicker"
import RadioSelect from "../../../components/FormComponents/RadioSelect";
import FormButtonLayout from "../../../components/LayoutComponents/FormButtonLayout";
import CustomTextField from "../../../components/FormComponents/CustomTextField";

export default function SkillProfileForm({ formData, setFormData, onSave, onDelete, session, competencies, proficiencies, skills, setSkills, loading }) {

    const [showSkillsPage, setShowSkillsPage] = useState(false)
    const [error, setError] = useState({});

    const handleSave = () => {
        const errors = {};

        if (!formData?.profileName || formData.profileName.trim() === "") {
            errors.profileName = "Profile Name is required";
        }

        if (!formData?.profileDescription || formData.profileDescription.trim() === "") {
            errors.profileDescription = "Profile Description is required";
        }
        if (!formData?.dutiesResponsibilities || formData.dutiesResponsibilities.trim() === "") {
            errors.dutiesResponsibilities = "Duties and Responsibilities is required";
        }
        if (!formData.effectiveStartDate) {
            errors.effectiveStartDate = "Effective Start Date is required."
        }
        if (formData?.effectiveStartDate && !formData?.effectiveEndDate) {
            errors.effectiveEndDate = "Effective End Date is required when a start date is chosen.";
        }
        if (
            formData?.effectiveStartDate &&
            formData?.effectiveEndDate &&
            new Date(formData.effectiveStartDate) > new Date(formData.effectiveEndDate)
        ) {
            errors.effectiveEndDate = "Effective End Date cannot be before start date.";
        }
        if (!formData?.entityId) {
            errors.company = "Company is required."
        }
        if (!formData?.industryId) {
            errors.industryId = "Industry is required."
        }
        if (!formData?.industryId){
            errors.industryId = "Industry is required."
        }
        if(!formData?.entityId){
            errors.entityId = "Company is required."
        }


        if (Object.keys(errors).length > 0) {
            setError(errors);
            return;
        }

        setError({});
        onSave();

    }

    const handleChange = (field, value) => {
        setFormData({ ...formData, [field]: value });
    };

    return (
        <>
            {showSkillsPage ? (
                <SelectSkills
                    competencies={competencies}
                    proficiencies={proficiencies}
                    selected={skills}
                    setSelected={setSkills}
                    setShowSkillsPage={setShowSkillsPage}
                    label={formData?.profileName || ""}
                    loading={loading}
                    error={Object.keys(error).length > 0}
                />
            ) :
                (<Paper sx={{ p: 3, display: "flex", flexDirection: "column", maxHeight: "60vh", overflowY: "auto" }}>
                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                        <Typography variant="h6">
                            Skill Profile Details
                        </Typography>
                        {loading && <LoadingCircle size={20} />}
                    </Box>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <CustomTextField
                                formData={formData}
                                field='profileName'
                                handleChange={handleChange}
                                required={true}
                                label={"Profile Name"}
                                error={error.profileName}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <CustomTextField
                                formData={formData}
                                field='profileDescription'
                                handleChange={handleChange}
                                required={true}
                                multiline={true}
                                rows={4}
                                label={"Profile Description"}
                                error={!!error.profileDescription}
                                helperText={error.profileDescription}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <CustomTextField
                                formData={formData}
                                field='dutiesResponsibilities'
                                handleChange={handleChange}
                                required={true}
                                multiline={true}
                                rows={4}
                                label={"Duties & Responsibilities"}
                                error={!!error.dutiesResponsibilities}
                                helperText={error.dutiesResponsibilities}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <RadioSelect value={formData?.activeFlag} label={formData.activeFlag ? "Active" : "Not Active"} onChange={(val) => handleChange("activeFlag", val)} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <CustomDatePicker
                                selectedDate={dayjs(formData?.effectiveStartDate)}
                                setSelectedDate={(value) => setFormData((prevState) => ({ ...prevState, effectiveStartDate: value }))}
                                label="Effective Start Date"
                                error={!!error.effectiveStartDate} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <CustomDatePicker
                                selectedDate={dayjs(formData?.effectiveEndDate)}
                                setSelectedDate={(value) => setFormData((prevState) => ({ ...prevState, effectiveEndDate: value }))}
                                label="Effective End Date"
                                error={!!error.effectiveEndDate} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <CustomDropdown
                                session={session}
                                value={formData?.entityId}
                                entityName="entityName"
                                entityIdField="entityId"
                                label="Company"
                                setEntity={(id) => handleChange("entityId", id)}
                                style={{ width: '100%' }}
                                error={!!error.company}
                                helperText={error.company}
                                request={partnersRequest}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <CustomDropdown
                                session={session}
                                value={formData?.industryId}
                                setEntity={(industryId) => handleChange("industryId", industryId)}
                                style={{ width: "100%" }}
                                label="Industry"
                                disabled={false}
                                request={industriesRequest}
                                entityName="industryName"
                                entityIdField="industryId"
                                error={!!error.industryId}
                                helperText={error.industryId}
                            />
                        </Grid>
                    </Grid>
                </Paper>
                )}
            <Box sx={{ mt: 2 }}>
                <FormButtonLayout
                    handleSave={handleSave}
                    onDelete={onDelete}
                    showSkillsPage={showSkillsPage}
                    setShowSkillsPage={setShowSkillsPage}
                    selected={formData?.profileId > 0}
                />
            </Box>
        </>
    )


}